import { render, staticRenderFns } from "./editTextBook.vue?vue&type=template&id=57376ed9&scoped=true&"
import script from "./editTextBook.vue?vue&type=script&lang=js&"
export * from "./editTextBook.vue?vue&type=script&lang=js&"
import style0 from "./editTextBook.vue?vue&type=style&index=0&id=57376ed9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57376ed9",
  null
  
)

export default component.exports